import type { Config } from '@grafana/faro-core';

/**
 * @deprecated Configure console instrumentation using the `consoleInstrumentation` object in the
 * Faro config.
 */
export type ConsoleInstrumentationOptions = Config['consoleInstrumentation'];
